export default __webpack_public_path__ + "static/media/m-banner-bg.5f932016.png";